export const payload = {
  receiveMutation: 'RECEIVE_CURRENCIES',
  receivingMutation: 'RECEIVING_CURRENCIES',
  receiveMetadataMutation: 'RECEIVE_CURRENCY_METADATA',
  receiveFailureMutation: 'RECEIVE_CURRENCY_FAILURE',
  savingMutation: 'SAVING_CURRENCY',
  saveFailureMutation: 'SAVING_CURRENCY_FAILURE',
  incrementMutation: 'INCREMENT_CURRENCY_COUNT',
  updatingMutation: 'UPDATING_CURRENCY',
  updateFailureMutation: 'UPDATING_CURRENCY_FAILURE',
  deleteMutation: 'DELETE_CURRENCY',
  deletingMutation: 'DELETING_CURRENCY',
  deleteFailureMutation: 'DELETING_CURRENCY_FAILURE',
  resetMetaMutation: 'RESET_CURRENCY_META',
  clearMutation: 'CLEAR_CURRENCY_STATE',
  moduleName: 'currency',
  endpoint: 'currencies',
  searchableFields: ['code', 'main_unit_name', 'fractional_unit_name']
}
